import {Divider, Drawer, Form, Select, Spin} from "antd";
import {useAppData} from "../../store/app-data";
import React from "react";
import {
    getProductCategoryHints,
    getEventHints,
    getLlwHints,
    getArticlesHints,
    getPromotionsHints,
    getProductHintsWithGroup,
    getPoints, getPointsTables
} from "src/utils";
import styled from "styled-components";
import {value} from "lodash/seq";

const START_LINK = "https://bushe.ru/screens/"

export function LinkBuilderDrawer({title, onClose, onBuild}) {
    const layoutConfig = useAppData((state) => state.layoutConfig)

    const [finalLink, setFinalLink] = React.useState("")
    const [visibleResult, setVisibleResult] = React.useState(null)
    const [categoryState, setCategoryState] = React.useState(false)
    const [productState, setProductState] = React.useState(false)
    const [articlesState, setArticlesState] = React.useState(false)
    const [promotionsState, setPromotionsState] = React.useState(false)
    const [llwState, setLlwState] = React.useState(false)
    const [eventsState, setEvensProductState] = React.useState(false)
    const [pointsState, setPointsState] = React.useState(false)
    const [tableState, setTableState] = React.useState(false)
    const [smallOptions, setSmallOptions] = React.useState([])
    const [fetching, setFetching] = React.useState(false)
    const [options, setOptions] = React.useState([])
    const fetchRef = React.useRef(0)
    const fetchTableRef = React.useRef(0)

    const [form] = Form.useForm()

    const firstOptions = [
        {
            label: "В каталог",
            value: "catalogMain"
        },
        {
            label: "В категорию в каталоге",
            value: "catalogCategory"
        },
        {
            label: "В карточку продукта",
            value: "catalogProduct"
        },
        {
            label: "В акции",
            value: "promotionsMain"
        },
        {
            label: "В карточку акции",
            value: "promotionsItem"
        },
        {
            label: "В новости",
            value: "newsMain"
        },
        {
            label: "В карточку новости",
            value: "newsItem"
        },
        {
            label: "В карточку статьи",
            value: "articleItem"
        },
        {
            label: "В карточку мероприятия",
            value: "eventsItem"
        },
        {
            label: "В мои промокоды",
            value: "profile/promocodesMain"
        },
        {
            label: "В мои уведомления",
            value: "profile/notificationsMain"
        },
        {
            label: "В мои заказы",
            value: "ordersMain"
        },
        {
            label: "В заказ у столика",
            value: "orders/tableTable"
        },
        {
            label: "В карту лояльности",
            value: "loyaltyMain"
        },
        {
            label: "В QR-code",
            value: "qr-codeMain"
        },
    ];

    function onSuccessBuild(value) {
        if (onBuild) {
            onBuild(value)
            clearState();
        } else {
            setVisibleResult(value)
        }
    }


    function onCloseBuilder() {
        onClose()
        clearState()
    }

    const loadOptions = (value) => {
        fetchRef.current += 1
        const fetchId = fetchRef.current

        setOptions([])
        setFetching(true)

        getProductHintsWithGroup(value).then((newOptions) => {
            const result = newOptions.data.items.map((product) => ({
                label: product.name,
                value: product.id,
                groupId: product.groupId,
                categoryId: product.categoryId,
            }))

            if (fetchId !== fetchRef.current) {
                return
            }

            setOptions(result)
            setFetching(false)
        }).catch(() => {
            if (fetchId === fetchRef.current) {
                setFetching(false)
            }
        })
    }

    const handleLoadTableOptions = (value) => {
        fetchTableRef.current += 1
        const fetchId = fetchTableRef.current

        setOptions([])
        setFetching(true)

        getPointsTables(value).then((newOptions) => {
            const result = newOptions.data.elements.map((table) => ({
                label: table.name,
                value: table.id,
                pointId: value,
            }))

            if (fetchId !== fetchTableRef.current) {
                return
            }

            setOptions(result)
            setFetching(false)
            setTableState(true)
        }).catch(() => {
            if (fetchId === fetchTableRef.current) {
                setFetching(false)
            }
        })
    }

    function handleFirstSelect(item) {
        clearState()
        if(item.includes("Main")) {
            if(item.includes("catalog")) {
                onSuccessBuild(`${START_LINK}catalog`)
            } else {
                onSuccessBuild(`${START_LINK}${item.replace("Main", "")}`)
            }
        } else {
            if(item.includes("catalog")) {
                setFinalLink(`${START_LINK}catalog/`)
                if (item.includes("Category")) {
                    getProductCategoryHints()
                        .then((response) => {
                            let data = [];
                            response.forEach((category) => {
                                data.push({
                                    label: category.name,
                                    value: category.id,
                                    groupId: category.groupProductCategoryIds[0],
                                })
                            })
                            setSmallOptions(data)
                        })
                    setCategoryState(true)
                } else if (item.includes("Product")) {
                    setProductState(true)
                }
            } else if (item.includes("Table")) {
                setFinalLink(`${START_LINK}${item.replace("Table", "")}/`)
                getPoints().then((response) => {
                    let data = [];
                    response.forEach((point) => {
                        data.push({
                            label: point.name,
                            value: point.id
                        })
                    })
                    setSmallOptions(data)
                    setPointsState(true)
                })
            } else {
                setFinalLink(`${START_LINK}${item.replace("Item", "")}/`)
                switch (item.replace("Item", "")) {
                    case "promotions":
                        getPromotionsHints()
                            .then((response) => {
                                let data = [];
                                response.forEach((category) => {
                                    data.push({
                                        label: category.name,
                                        value: category.id,
                                    })
                                })
                                setSmallOptions(data)
                            })
                        setPromotionsState(true)
                        break;
                    case "news":
                        getArticlesHints()
                            .then((response) => {
                                let data = [];
                                response.forEach((category) => {
                                    data.push({
                                        label: category.name,
                                        value: category.id,
                                    })
                                })
                                setSmallOptions(data)
                            })
                        setArticlesState(true)
                        break;
                    case "article":
                        getLlwHints()
                            .then((response) => {
                                let data = [];
                                response.forEach((category) => {
                                    data.push({
                                        label: category.name,
                                        value: category.id,
                                    })
                                })
                                setSmallOptions(data)
                            })
                        setLlwState(true)
                        break;
                    case "events":
                        getEventHints()
                            .then((response) => {
                                let data = [];
                                response.forEach((category) => {
                                    data.push({
                                        label: category.name,
                                        value: category.id,
                                    })
                                })
                                setSmallOptions(data)
                            })
                        setEvensProductState(true)
                        break;
                }
            }
        }
    }

    function clearState() {
        setFinalLink("")
        setVisibleResult(false)
        setCategoryState(false)
        setProductState(false)
        setArticlesState(false)
        setPromotionsState(false)
        setLlwState(false)
        setEvensProductState(false)
        setPointsState(false)
        setTableState(false)
        setSmallOptions([])
        setOptions([])
        setFetching(false)
    }

    function handleSecondSelect(item) {
        if (categoryState) {
            onSuccessBuild(`${finalLink}${item}`)
            if (onBuild) {
                clearState()
            }
        } else if(productState) {
            let findItem = options.find((element) => element.value === item.value)
            onSuccessBuild(`${finalLink}${findItem.categoryId}/${item.value}`)
            if (onBuild) {
                clearState()
            }
        } else if (tableState) {
            let findItem = options.find((element) => element.value === item.value)
            onSuccessBuild(`${finalLink}${findItem.pointId}/${findItem.value}`)
            if (onBuild) {
                clearState()
            }
        } else {
            onSuccessBuild(`${finalLink}${item}`)
            if (onBuild) {
                clearState()
            }
        }
    }

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={onCloseBuilder}
            open
        >
            <FormEdit
                form={form}
                layout={"vertical"}
                onFinish={false}
            >
                <StyledFormItem
                    key={"first_link"}
                    label={"Куда переход"}
                >
                    <Select options={firstOptions} onSelect={handleFirstSelect}/>
                </StyledFormItem>

                {categoryState && smallOptions.length > 0 && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Категория"}
                    >
                        <Select options={smallOptions} onSelect={handleSecondSelect}/>
                    </StyledFormItem>
                )}

                {productState && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Продукт"}
                    >
                        <Select
                            showSearch={true}
                            labelInValue
                            filterOption={false}
                            onSearch={loadOptions}
                            notFoundContent={
                                <span style={{ display: 'flex', justifyContent: 'center' }}>
                                    {fetching ? <Spin size="small" /> : 'Ничего не найдено'}
                                </span>
                            }
                            options={options}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}

                {articlesState && smallOptions.length > 0 &&  (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Новость"}
                    >
                        <Select
                            showSearch={true}
                            options={smallOptions}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}

                {promotionsState && smallOptions.length > 0 && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Акции"}
                    >
                        <Select
                            showSearch={true}
                            options={smallOptions}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}

                {llwState && smallOptions.length > 0 && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Статьи"}
                    >
                        <Select
                            showSearch={true}
                            options={smallOptions}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}

                {eventsState && smallOptions.length > 0 && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Мероприятия"}
                    >
                        <Select
                            showSearch={true}
                            options={smallOptions}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}

                {pointsState && smallOptions.length > 0 && (
                    <StyledFormItem
                        key={"point_select"}
                        label={"Точка"}
                    >
                        <Select
                            optionFilterProp="label"
                            showSearch={true}
                            options={smallOptions}
                            onSelect={handleLoadTableOptions}
                        />
                    </StyledFormItem>
                )}
                {tableState && (
                    <StyledFormItem
                        key={"second_select"}
                        label={"Стол"}
                    >
                        <Select
                            labelInValue
                            optionFilterProp="label"
                            showSearch={true}
                            options={options}
                            onSelect={handleSecondSelect}
                        />
                    </StyledFormItem>
                )}
            </FormEdit>

            {(!onBuild && visibleResult) &&
                <>
                    <Divider orientation={"left"}>Результат</Divider>
                    <h2>{visibleResult}</h2>
                    <br/>
                    <h4>Скопируйте результат в ставьте в поле для ссылки</h4>
                </>

            }
        </DrawerEdit>
    )
}

const DrawerEdit = styled(Drawer)``

const FormEdit = styled(Form)``

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`
